import { shallowEqual, useSelector } from 'react-redux';
import { formatDateTimeUA } from 'helpers/formatDate';
import styles from './UserPage.scss';

export const UserLastActivityBadge = ({ userID }) => {
  const status = useSelector((state) => state.users.statuses[userID], shallowEqual);

  return (
    status?.lastSeen &&
    !status.isOnline && (
      <div className={styles.metaItem}>
        <strong>Остання активність: </strong>
        {formatDateTimeUA(status.lastSeen, true)}
      </div>
    )
  );
};
